import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core'

interface styleProps {
    isOMorSMM: boolean | undefined
}
export const useWorkspace2ActionBarStyles = makeStyles((theme: Theme) => ({
    showHideContainer: {
        background: theme.palette.common.white,
        height: pxToRem(56),
        color: '#314959',
        position: 'absolute',
        left: 0,
        top: theme.spacing(0.5),
        display: 'flex',
        justifyContent: 'center',
        fontSize: pxToRem(14),
    },
    contentContainer: {
        height: '100%',
        padding: theme.spacing(0, 1.5),
        justifyContent: 'center',
    },
    actionContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    switchContainer: {
        textAlign: 'right',
        alignContent: 'center',
    },
    shortcutKeyContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingBottom: pxToRem(5),
        gap: pxToRem(3),
        color: '#185E8E',
        fontSize: pxToRem(10),
    },
    exportLabel: {
        fontFamily: 'Roboto',
        fontWeight: 500,
        fontSize: '12px',
        lineHeight: '100%',
        letterSpacing: '0%',
        textAlign: 'center',
        color: '#314959',
    },
    divider: {
        background: '#00000040',
        alignSelf: 'center',
        height: pxToRem(18),
        width: pxToRem(2),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    evaluationsButton: {
        border: '1px solid #c9c9c9',
        borderRadius: pxToRem(100),
        color: '#314959',
        lineHeight: 1.43,
        height: pxToRem(26),
        fontSize: pxToRem(12),
        padding: theme.spacing(0.625, 1.25),
        whiteSpace: 'nowrap',
    },
    iconButton: {
        fontSize: pxToRem(16),
        '&.MuiSvgIcon-root': {
            fontSize: pxToRem(16),
            color: '#314959',
        },
        '&.InsertPillIcon': {
            width: pxToRem(20),
            height: pxToRem(12),
        },
    },
    iconButtonVisibilitySettings: {
        fontSize: pxToRem(20),
        marginLeft: theme.spacing(0.35),
        '&.MuiSvgIcon-root': {
            fontSize: pxToRem(20),
            color: '#314959',
        },
    },
    iconButtonDisabled: {
        '&.MuiSvgIcon-root': {
            fontSize: pxToRem(16),
            color: '#C9C9C9',
        },
    },
    editorContentContainer: {
        padding: theme.spacing(3.5, 1.5),
        justifyContent: 'center',
    },
    roundContainerActionBar: {
        width: ({ isOMorSMM }: styleProps) =>
            isOMorSMM ? pxToRem(220) : pxToRem(133.68),
        height: pxToRem(34),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: theme.spacing(1, 1.25),
        backgroundColor: theme.palette.common.white,
        boxShadow: '0px 0px 4px 0px rgba(0,0,0,0.25)',
        borderRadius: '20px',
        flexShrink: 0,
        position: 'relative',
    },
    loadingIcon: {
        verticalAlign: 'middle',
    },
    viewText: {
        color: '#777777',
        fontSize: pxToRem(14),
        marginLeft: theme.spacing(0.5),
        marginBottom: theme.spacing(0.625),
    },
    menuItemContainer: {
        width: 170,
        alignItems: 'center',
    },
    menuItemLabel: {
        marginLeft: theme.spacing(1),
        fontSize: pxToRem(14),
        color: '#424242',
    },
    visibilityExpandIcon: {
        fontSize: '20px !important',
        marginLeft: -theme.spacing(0.25),
    },
    visibiltySettingWrapper: {
        boxShadow:
            '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
        borderRadius: 4,
        width: 194,
        height: 140,
        backgroundColor: theme.palette.common.white,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        paddingLeft: theme.spacing(1.5),
    },
}))
